import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/landing-page/services/corporate-cards/page.tsx");
